import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import { Box, Button, Typography } from "@mui/material";

function OrdersEmptyState({ tab, onClearFilters, onViewAll }) {
  return (
    <Box
      sx={{
        height: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "text.secondary",
        gap: 1.5,
      }}
    >
      <AssignmentOutlinedIcon sx={{ fontSize: 64, color: "grey.400" }} />

      <Typography variant="h6" color="text.primary">
        No orders in “{tab}”
      </Typography>

      <Typography variant="body2" sx={{ maxWidth: 360 }}>
        Orders will appear here once they move into this stage.
        Try adjusting filters or checking other tabs.
      </Typography>

      {/* <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
        <Button variant="outlined" onClick={onClearFilters}>
          Clear filters
        </Button>
        <Button variant="contained" onClick={onViewAll}>
          View all orders
        </Button>
      </Box> */}
    </Box>
  );
}
export default OrdersEmptyState;